import "./Dash.css"
import { FiBell, FiCalendar, FiHome, FiMail, FiMapPin, FiUser } from 'react-icons/fi'
import { useUserData } from '../Contexts/UserDataContext'

const DashboardProfile = () => {
  const { userData } = useUserData()
  const detailRows = [
    { label: 'Name', value: userData?.name || 'Not provided', icon: FiUser },
    { label: 'Email', value: userData?.email || 'Not provided', icon: FiMail },
    { label: 'Address', value: userData?.address || 'Indian Park residence', icon: FiMapPin },
  ]

  return (
    <div className="dashboard-grid">
      <section className="dash-card welcome-card">
        <div className="welcome-icon"><FiHome /></div>
        <span className="dash-card-label">Welcome home</span>
        <h2>Hello, {userData?.name?.split(' ')[0] || 'neighbor'}.</h2>
        <p>Your resident portal keeps community information and association services in one easy place.</p>
      </section>

      <section className="dash-card account-card">
        <div className="dash-card-heading">
          <div><span className="dash-card-label">Account</span><h2>Resident details</h2></div>
          <span className={`status-pill ${userData?.approved ? 'approved' : 'pending'}`}>{userData?.approved ? 'Approved' : 'Pending review'}</span>
        </div>
        <div className="account-details">
          {detailRows.map(({ label, value, icon: Icon }) => (
            <div className="account-row" key={label}>
              <span><Icon /></span>
              <div><small>{label}</small><strong>{value}</strong></div>
            </div>
          ))}
        </div>
      </section>

      <section className="dash-card info-card">
        <FiBell />
        <div><strong>Community alerts</strong><p>If you opted in, important updates will arrive by email or text.</p></div>
      </section>
      <section className="dash-card info-card">
        <FiCalendar />
        <div><strong>Upcoming events</strong><p>Visit the public home page for the latest community calendar.</p></div>
      </section>
    </div>
  )
}

export default DashboardProfile;
